module.exports = __webpack_public_path__ + "media/Lane Hall Section 1.963f32a1.mp3";